import { useCallback, useState } from "react";
import { throwResponseError } from "../../utils/api-error-utils";
import { getAuthParams } from "../../utils/pacto-rebates-utils";
import {
	formatOngoingAssessmentCyclesResponse
} from "../utils/installments-assessment-utils";

export function useOngoingAssessmentCycles() {
	const [cycles, setCycles] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const fetchOngoingAssessmentCycles = useCallback(async () => {
		try {
			setLoading(true);
			setError(null);

			const { accessToken, clientId } = getAuthParams();

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
					"pacto-rebates-apuracao/v1/apuracoes/ciclos/em-andamento",
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"access_token": accessToken,
						"client_id": clientId
					}
				}
			);

			if (!response.ok) {
				await throwResponseError(
					response,
					"Não foi possível carregar os ciclos em andamento."
				);
			}

			const data = await response.json();

			if (!Array.isArray(data)) {
				throw new Error(
					"A resposta dos ciclos em andamento possui formato inválido."
				);
			}

			const formattedCycles =
				formatOngoingAssessmentCyclesResponse(data);

			setCycles(formattedCycles);

			return {
				ok: true,
				cycles: formattedCycles,
				empty: formattedCycles.length === 0
			};
		} catch (requestError) {
			const errorMessage =
				requestError.message ||
				"Não foi possível carregar os ciclos em andamento.";

			setCycles([]);
			setError(errorMessage);

			return {
				ok: false,
				reason: "request",
				error: errorMessage
			};
		} finally {
			setLoading(false);
		}
	}, []);

	const clearCycles = useCallback(() => {
		setCycles([]);
		setError(null);
	}, []);

	return {
		cycles,
		loading,
		error,
		refetch: fetchOngoingAssessmentCycles,
		clearCycles
	};
}